import { ConfiguracionTour } from '../../services/tour-tutorial.service';

export class ConfiguracionesTour  {
  
  /**
   * Configuración del tour para el wizard de emisor
   */
  static readonly WIZARD_EMISOR: ConfiguracionTour  = {
    tourId: 'wizTourDone',
    steps: [
      {
        element: '#wizStepDatosEmpresa',
        intro: 'Aquí es la identificación de la empresa que emitirá y/o recibirá DTEs.',
        position: 'top',
        wizardStep: 0
      },
      {
        element: '#wizStepActividadEco',
        intro: 'Busque y seleccione su(s) actividad(es) económica(s).',
        position: 'bottom',
        wizardStep: 1,
        highlightElement: 'ng-select[formControlName="actividadEconomica"]'
      },
      {
        element: '#wizStepCertificadoDigital',
        intro: 'Debe contar con un certificado digital para emitir documentos. Si no cuenta con uno, puede adquirirlo con nosotros.',
        position: 'bottom',
        wizardStep: 2
      },
      {
        element: '#wizStepLogo',
        intro: 'Este logo aparecerá en todos sus documentos.',
        position: 'bottom',
        wizardStep: 3
      },
      {
        element: '#wizStepPlanes',
        intro: 'Seleccione el plan que más se ajuste a la necesidad de su empresa.',
        position: 'bottom',
        wizardStep: 4
      },
      {
        element: '#wizStepCertificacion',
        intro: ' La certificación sólo debe solicitarla cuando es primera vez que emitirá documentos electrónicos por un sistema de mercado, es decir, si actualmente ocupa el portal gratuito del SII para emitir.',
        position: 'bottom',
        wizardStep: 4
      },
      {
        element: '#wizStepFormaPago',
        intro: 'Puede visualizar el detalle de su contratación. Contamos con adicionales y la opción de usar 7 dias gratis antes de pagar.',
        position: 'left',
        wizardStep: 4
      },
       {
        element: '#wizStepAmbiente',
        intro: 'Estos datos dependerán del ambiente en el que trabaje. Seleccione "PRUEBAS QA" si quiere iniciar en modo de pruebas. Seleccione producción si está todo listo para emitir documentos reales.',
        position: 'top',
        wizardStep: 5
      },
      {
        element: '#wizPassSII',
        intro: 'La password del SII la solicitamos para sincronizar sus compras y boletas de honorarios. No es un campo obligatorio.',
        position: 'top',
        wizardStep: 5
      },
      {
        element: '#wizStepConfiguracion',
        intro: 'Aquí puede configurar opciones adicionales, como el envío automático de correos al emitir documentos, los datos de resolución y otros detalles importantes.',
        position: 'bottom',
        wizardStep: 5
      },
      {
        element: '#wizStepDatosFacturacion',
        intro: 'Finalmente, debe ingresar los datos de la empresa a la cual se emitirá la factura por esta contratación. Puede usar los mismos datos de la empresa que ingresó.',
        position: 'top',
        wizardStep: 6
      },
    ],
    showStepNumbers: true,
    exitOnOverlayClick: false,
    showButtons: true,
    nextLabel: 'Siguiente',
    prevLabel: 'Anterior',
    doneLabel: 'Cerrar',
    overlayOpacity: 0.5,
    showBullets: false,
    scrollToElement: true,
    disableInteraction: false,
  };

  /**
   * Recorrido breve para preparar y revisar un documento en el facturador individual.
   */
  static readonly FACTURADOR_INDIVIDUAL: ConfiguracionTour = {
    tourId: 'facturadorIndividualTourDone',
    steps: [
      {
        element: '.facturador-header__titulo',
        intro: 'Prepare su documento paso a paso. Aquí puede revisar qué documento está creando y cuántos folios tiene disponibles para emitir.',
        position: 'bottom'
      },
      {
        element: '#tour-cliente',
        intro: 'Busque y seleccione al cliente o proveedor al que corresponde el documento. Revise sus datos antes de continuar.',
        position: 'bottom'
      },
      {
        element: '#tour-panel-complementario .panel-complementario',
        intro: 'Aquí puede relacionar otros documentos en Referencias, completar datos de Transporte y escribir Observaciones. Según el documento, también encontrará Comisiones y otros cargos, Tipo de nota y Opciones adicionales. Abra la sección que necesite; cerrarla no borra los datos ingresados. Las notas de crédito y débito necesitan una referencia.',
        position: 'bottom'
      },
      {
        element: '#tour-detalle-productos',
        intro: 'Busque y seleccione lo que desea agregar: productos o servicios, o documentos si prepara una liquidación. También puede ingresar una línea manualmente y ajustar su cantidad y precio. Use “Expandir descripciones” para abrir los datos adicionales de todas las líneas.',
        position: 'top'
      },
      {
        element: '#tour-resumen-documento',
        intro: 'En Especificaciones, revise el formato, la fecha y la forma de pago. En Resumen, compruebe los impuestos y el total antes de generar el documento.',
        position: 'left'
      },
      {
        element: '#grupo_boton_generar',
        intro: 'Cuando haya revisado los datos, pulse Generar para emitir el documento. En la flecha de al lado encontrará “Generar y guardar frecuente”, para emitirlo y guardar sus datos como base para futuros documentos.',
        position: 'bottom'
      },
    ],
    showStepNumbers: true,
    exitOnOverlayClick: false,
    showButtons: true,
    nextLabel: 'Siguiente',
    prevLabel: 'Anterior',
    doneLabel: 'Entendido',
    overlayOpacity: 0.5,
    showBullets: false,
    scrollToElement: true,
    disableInteraction: false,
  };

  /**
   * Configuración del tour para el formulario de creación de cuenta Payku
   */
  static readonly PAYKU_FORMULARIO: ConfiguracionTour = {
    tourId: 'paykuFormTour',
    steps: [
      {
        element: '#section-personal',
        intro: 'En esta sección debes ingresar tu información personal, como tu nombre completo el cual debe ser igual al que aparece en su cédula de identidad, <strong>correo electrónico al cual se va a asociar la cuenta payku y recibirás las notificaciones</strong>. Asegúrate de que toda la información sea correcta para evitar problemas al crear tu cuenta Payku.',
        position: 'bottom'
      }
    ],
    showStepNumbers: true,
    exitOnOverlayClick: false,
    showButtons: true,
    nextLabel: 'Siguiente',
    prevLabel: 'Anterior',
    doneLabel: 'Finalizar',
    overlayOpacity: 0.5,
    showBullets: false,
    scrollToElement: true,
    disableInteraction: false,
  };
}
